import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from 'react-redux';
import { createDiscount } from "../../slices/discount";
import { useNavigate } from 'react-router-dom';

const DiscountForm = ({ planGroup }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        getValues,
        formState: { errors }
    } = useForm();
    
    const discount = watch('discount', 50)

    useEffect(() => {
        setValue('discount', discount)
    }, [setValue, discount])

    useEffect(() => {
        for (let e of document.querySelectorAll('input[type="range"].slider-progress')) {
            e.style.setProperty('--value', e.value);
            e.style.setProperty('--min', e.min == '' ? '0' : e.min);
            e.style.setProperty('--max', e.max == '' ? '100' : e.max);
            e.addEventListener('input', () => e.style.setProperty('--value', e.value));
          }
          }, []);

    const onSubmit = (data) => {
        Promise.resolve(dispatch(createDiscount(data)))
        .then(data => {
            navigate('/settings/discounts/')
        })
    }


    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="contentarea clamped">
                <div className="container-fluid detail">
                    <div className="row">
                        <div className="col-8 mb-4">
                            <label>{gettext('Discount Group Name')}</label>
                            <input type="text" {...register("name", { required: true })} className="form-control" />
                        </div>
                        <div className="col-4 mb-4">
                            <label>{gettext('Discount Group Percentage')}</label>
                            <div className="d-flex align-items-center">
                                <input type="range" min="0" max="100" value={discount} onChange={(e) => setValue('discount', e.target.value)} className="form-range styled-slider slider-progress" />
                                <div className="input-group input-group-percentage w-50 ms-4">
                                    <input type="number" min="0" max="100" value={discount} onChange={(e) => setValue('discount', e.target.value)} className="form-control" />
                                    <span>%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="clamped text-end">
                <input className="btn btn-primary mt-4 ms-auto" type="submit" value={gettext("Save")} />
            </div>
        </form>
    )
}

export default DiscountForm